<template>
    <div>
        <div class="desktop-hidden text-center">
            <span class="header-hm mt-6 text-white block" v-text="$options.filters['lang']('copy.our_community')"></span>
            <span class="header-hm text-orange block lowercase" v-text="$options.filters['lang']('copy.in_numbers')"></span>
        </div>
        <VueSlickCarousel v-bind="settings">
            <div class="facts-tile" v-for="fact in facts">
                <div class="fact-tile">
                    <p class="uppercase headline-spacing-1" v-text="fact.section"></p>
                    <h2 class="leading-tight title-hm" v-text="formatNumber(fact.value)"></h2>
                </div>
            </div>
        </VueSlickCarousel>
    </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
    name: 'Factscarousel',
    props: [
        'facts'
    ],
    methods: {
        formatNumber(value) {
            const num = parseFloat(value);
            if (isNaN(num)) {
                return value;
            }

            if (num >= 10000) {
                return num.toLocaleString('en-US');
            }

            return value;
        }
    },
    components: { VueSlickCarousel },
    data() {
        return {
            settings: {
                "focusOnSelect": true,
                "infinite": false,
                "speed": 500,
                "slidesToShow": 4,
                "slidesToScroll": 4,
                "touchThreshold": 5,
                "adaptiveHeight": true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            "arrows": true,
                            "edgeFriction": 0.35,
                            "infinite": true,
                            "speed": 500,
                            "slidesToShow": 1,
                            "slidesToScroll": 1
                        }
                    }
                ]
            },
        }
    },
}
</script>

<style scoped>

</style>
